/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

export enum EvaluationEngine {
  BASE = "BASE",
  MOOSHAK = "MOOSHAK",
}

export enum GameStateEnum {
  CLOSED = "CLOSED",
  LOCKED = "LOCKED",
  OPEN = "OPEN",
}

export enum Mode {
  DUEL = "DUEL",
  HACK_IT = "HACK_IT",
  NORMAL = "NORMAL",
  SHAPESHIFTER = "SHAPESHIFTER",
  SHORTENING = "SHORTENING",
  SPEEDUP = "SPEEDUP",
  TIME_BOMB = "TIME_BOMB",
}

export enum Result {
  ACCEPT = "ACCEPT",
  ASK_FOR_REEVALUATION = "ASK_FOR_REEVALUATION",
  COMPILATION_ERROR = "COMPILATION_ERROR",
  OUTPUT_LIMIT_OVERFLOW = "OUTPUT_LIMIT_OVERFLOW",
  PROCESSING = "PROCESSING",
  RESOURCE_USAGE_EXCEEDED = "RESOURCE_USAGE_EXCEEDED",
  RUNTIME_ERROR = "RUNTIME_ERROR",
  TIMEOUT = "TIMEOUT",
  WRONG_ANSWER = "WRONG_ANSWER",
}

export enum RewardType {
  BADGE = "BADGE",
  COUPON = "COUPON",
  HINT = "HINT",
  MESSAGE = "MESSAGE",
  POINT = "POINT",
  REVEAL = "REVEAL",
  UNLOCK = "UNLOCK",
  VIRTUAL_ITEM = "VIRTUAL_ITEM",
}

export enum State {
  AVAILABLE = "AVAILABLE",
  COMPLETED = "COMPLETED",
  FAILED = "FAILED",
  HIDDEN = "HIDDEN",
  LOCKED = "LOCKED",
  OPENED = "OPENED",
  REJECTED = "REJECTED",
}

//==============================================================
// END Enums and Input Objects
//==============================================================
